import { render } from "./FooterPage.vue?vue&type=template&id=0aa9b385&ts=true"
import script from "./FooterPage.vue?vue&type=script&lang=ts"
export * from "./FooterPage.vue?vue&type=script&lang=ts"

import "./FooterPage.vue?vue&type=style&index=0&id=0aa9b385&lang=css"

import exportComponent from "C:\\Paii\\Projects\\TT Exclusive\\ttex_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__